import { Category } from "@/schema/free-assessment/Category";
import { SubCategory as TSubCategory } from "@/schema/free-assessment/SubCategory";
import Question from "@/src/free-assessment/questions/_components/Category/SubCategory/Question";
import { QuestionCircleRegular } from "@fluentui/react-icons";
import { Fragment } from "react";
import { Control, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface SubCategoryProps {
  categoryIndex: number;
  subCategoryIndex: number;
  control: Control<{ categories: Category[] }>;
  subCategory: TSubCategory;
}

function SubCategory({
  categoryIndex,
  subCategoryIndex,
  subCategory: { content, questions },
  control,
}: SubCategoryProps) {
  const { t } = useTranslation();
  const { fields } = useFieldArray({
    control,
    name: `categories.${categoryIndex}.sub_categories.${subCategoryIndex}.questions`,
  });

  return (
    <div>
      <div className="mt-5 text-lg font-bold">{content}</div>
      <div className="flex items-center gap-1">
        <QuestionCircleRegular fontSize={20} />
        <div>{questions.length} {t("question-counter")}</div>
      </div>
      <div className="sm:my-card mt-8">
        {fields.map((question, index) => (
          <Fragment key={question.id}>
            <Question
              categoryIndex={categoryIndex}
              subCategoryIndex={subCategoryIndex}
              questionIndex={index}
              control={control}
            />
            {fields.length - 1 !== index && (
              <div className="h-px bg-cool-gray-200" />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
}

export default SubCategory;
